import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../layouts/AppLayout';
import useAuth from '../hooks/useAuth';
import useActiveCondominio from '../hooks/useActiveCondominio';
import { useFeatures } from '../hooks/useFeatures';
import './ConfigMenu.css';

const ConfigMenu = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { activeCondominio } = useActiveCondominio();
  const { isEnabled } = useFeatures();

  // Cards disponíveis para admin
  const allCards = [
    {
      id: 'alertas',
      title: 'Gerenciar Alertas',
      description: 'Configure alertas de nível de reservatório, conexão e canais inativos',
      icon: '🔔',
      path: '/configuracoes/alertas',
      color: '#4A90E2',
      requiredRole: ['admin', 'sindico'] // Admin e síndico podem acessar
    },
    {
      id: 'features',
      title: 'Gerenciar Features',
      description: 'Controle quais funcionalidades estão disponíveis no condomínio',
      icon: '🚀',
      pathFn: (condominioId) => `/configuracoes/features/${condominioId}`,
      color: '#FF6B6B',
      requiredRole: ['admin'] // Apenas admin
    },
    {
      id: 'usuarios',
      title: 'Gerenciar Usuários',
      description: 'Adicione, edite ou remova usuários do sistema',
      icon: '👥',
      path: '/configuracoes/usuarios',
      color: '#7B68EE',
      requiredRole: ['admin', 'sindico'], // Admin e síndico podem acessar
      featureName: 'usuarios' // Feature correspondente
    }
  ];

  // Filtrar cards que o usuário tem acesso e feature está ativa
  const configCards = allCards.filter(
    card => {
      // Verificar permissão de role
      if (card.requiredRole && !card.requiredRole.includes(user?.cargo)) {
        return false;
      }
      // Verificar se feature está ativa (se card possui featureName)
      if (card.featureName && !isEnabled(card.featureName)) {
        return false;
      }
      return true;
    }
  );

  const handleCardClick = (card) => {
    if (!card.disabled) {
      if (card.pathFn) {
        // Se card requer parâmetro dinâmico (como condominioId)
        // Extrair ID do objeto condominio
        const condominioId = activeCondominio || user?.condominios?.[0]?.id || 1;
        navigate(card.pathFn(condominioId));
      } else if (card.path) {
        navigate(card.path);
      }
    }
  };

  return (
    <AppLayout
      titulo="Configurações do Sistema"
      cargo={user?.cargo}
      problemas={[]}
    >
      <div className="config-menu-container">
        <div className="config-menu-content">
          <div className="config-menu-header">
            <h1>Configurações do Sistema</h1>
            <p>Selecione uma opção abaixo para gerenciar as configurações</p>
          </div>

          <div className="config-menu-grid">
            {configCards.map((card) => (
              <div
                key={card.id}
                className={`config-card ${card.disabled ? 'config-card-disabled' : ''}`}
                onClick={() => handleCardClick(card)}
                style={{ borderTopColor: card.color }}
              >
                <div className="config-card-icon" style={{ backgroundColor: `${card.color}20` }}>
                  <span style={{ color: card.color }}>{card.icon}</span>
                </div>
                <div className="config-card-content">
                  <h2>{card.title}</h2>
                  <p>{card.description}</p>
                </div>
                {!card.disabled && (
                  <div className="config-card-arrow" style={{ color: card.color }}>
                    →
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default ConfigMenu;
